module.exports = __webpack_public_path__ + "static/img/yikang2.8271ca83.png";